import styles from './Modal.module.css';
import Logo from '../../assets/eseoLogo.svg';
import AppStore from '../../assets/appStore.svg';
import GooglePlay from '../../assets/googlePlay.svg';
import Cross from '../../assets/cross.svg';

const Modal = ({showModal, setShowModal}) => {

    const onClick = () => {
        window.open('https://apps.apple.com/us/app/eseo-local-runner-community/id1589957665', '_blank');
    }
    return (
        <div className={styles.backdropContainer} style={{display: showModal ? 'block' : 'none'}}>
        <div className={styles.modalContainer}>
            <div className={styles.headContainer}>
                <img src={Cross} alt="Cross" onClick={() => setShowModal(false)} />
            </div>
            <img src={Logo} alt="Logo" />
            <p>To view details download our app from store</p>
            <div className={styles.storeContainer}>
                <img src={AppStore} alt="AppStore" onClick={onClick} />
                <img src={GooglePlay} alt="GooglePlay" onClick={onClick} />
            </div>
        </div>
        </div>
    )
}

export default Modal;